import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import { constants } from 'cng-web-lib'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  const errMsgAlphaNumericWithSpecialChar = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_ALPHA_NUMERIC_WITH_SPECIAL_CHAR
  )

  const errMsgAlphaNumericWithSpecialCharNoSpace = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_ALPHA_NUMERIC_WITH_SPECIAL_CHAR_NO_SPACE
  )

  const errMsgNumeric = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_NUMERIC
  )

  const errMsgMaxLength = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_MAX_LENGTH
  )

  const regexAlphaNumericWithSpecialCharNoSpace =
    '^[a-zA-Z0-9,+\\-$#@%&()!\'`^_:;.?\\[\\]\\{\\}\\/="\\|\\\\]+$'

  return Yup.object({
    billNo: Yup.string().nullable(),
    parentBillNo: Yup.string().nullable(),
    containerNumber: Yup.string().nullable().required(requiredMessage).matches(regexAlphaNumericWithSpecialCharNoSpace, errMsgAlphaNumericWithSpecialCharNoSpace).max(17, errMsgMaxLength + " 17"),
    containerSize: Yup.string().nullable().required(requiredMessage),
    containerLoadStatus: Yup.string().nullable().required(requiredMessage),
    sealIdentifier: Yup.string().nullable().required(requiredMessage).max(35, errMsgMaxLength + " 35"),
    containerStatusDescription: Yup.string().nullable().max(35, errMsgMaxLength + " 35"),
    containerVgm: Yup.string().nullable().max(18, errMsgMaxLength + " 18"),
    containerVgmUnit: Yup.string().nullable().when('containerVgm', {
      is: (val) => !!val,
      then: Yup.string().nullable().required(requiredMessage),
    }),
    temperatureType: Yup.string().nullable(),
    containerTemperature: Yup.string().nullable().max(15, errMsgMaxLength + " 15"),
    temperatureMeasurementCode: Yup.string().nullable().when('containerTemperature', {
      is: (val) => !!val,
      then: Yup.string().nullable().required(requiredMessage),
    }),
    serviceRequirementCode: Yup.string().nullable(),
    cargoType: Yup.string().nullable().required(requiredMessage),
    sealingPartyCode: Yup.string().nullable(),
    sealingPartyName: Yup.string().nullable().max(35, errMsgMaxLength + " 35"),
    sealType: Yup.string().nullable(),
  })
}

export default makeValidationSchema
